/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R500RouteImport } from './routes/500'
import { Route as AccountsRouteImport } from './routes/accounts'
import { Route as AgeVerificationRouteImport } from './routes/age-verification'
import { Route as BuyVoucherRouteImport } from './routes/buy-voucher'
import { Route as DonateRouteImport } from './routes/donate'
import { Route as FriendsRouteImport } from './routes/friends'
import { Route as LinkRouteImport } from './routes/link'
import { Route as LinkWorldRouteImport } from './routes/link-world'
import { Route as OauthRedirectRouteImport } from './routes/oauth-redirect'
import { Route as PartyRouteImport } from './routes/party'
import { Route as PrivatePartiesRouteImport } from './routes/private-parties'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as SafetyRouteImport } from './routes/safety'
import { Route as ScheduleRouteImport } from './routes/schedule'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SurveyRouteImport } from './routes/survey'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as VoucherRequestRouteImport } from './routes/voucher-request'
import { Route as AuctionsIndexRouteImport } from './routes/auctions/index'
import { Route as AuctionsIdRouteImport } from './routes/auctions/$id'
import { Route as CheckoutIndexRouteImport } from './routes/checkout/index'
import { Route as CheckoutCancelRouteImport } from './routes/checkout/cancel'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success'
import { Route as ExploreIndexRouteImport } from './routes/explore/index'
import { Route as ExploreClubFynnRouteImport } from './routes/explore/club-fynn'
import { Route as ExploreCommunityMeetupsRouteImport } from './routes/explore/community-meetups'
import { Route as ExploreDealersRouteImport } from './routes/explore/dealers'
import { Route as ExploreEventsRouteImport } from './routes/explore/events'
import { Route as ExploreGamesRouteImport } from './routes/explore/games'
import { Route as ExploreLobbyRouteImport } from './routes/explore/lobby'
import { Route as ExploreMeetupsRouteImport } from './routes/explore/meetups'
import { Route as ExploreDealerIdRouteImport } from './routes/explore/dealer.$id'
import { Route as ExploreEventIdRouteImport } from './routes/explore/event.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R500Route = R500RouteImport.update({
  id: '/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsRoute = AccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const AgeVerificationRoute = AgeVerificationRouteImport.update({
  id: '/age-verification',
  path: '/age-verification',
  getParentRoute: () => rootRouteImport,
} as any)
const BuyVoucherRoute = BuyVoucherRouteImport.update({
  id: '/buy-voucher',
  path: '/buy-voucher',
  getParentRoute: () => rootRouteImport,
} as any)
const DonateRoute = DonateRouteImport.update({
  id: '/donate',
  path: '/donate',
  getParentRoute: () => rootRouteImport,
} as any)
const FriendsRoute = FriendsRouteImport.update({
  id: '/friends',
  path: '/friends',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkRoute = LinkRouteImport.update({
  id: '/link',
  path: '/link',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkWorldRoute = LinkWorldRouteImport.update({
  id: '/link-world',
  path: '/link-world',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthRedirectRoute = OauthRedirectRouteImport.update({
  id: '/oauth-redirect',
  path: '/oauth-redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const PartyRoute = PartyRouteImport.update({
  id: '/party',
  path: '/party',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivatePartiesRoute = PrivatePartiesRouteImport.update({
  id: '/private-parties',
  path: '/private-parties',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const SafetyRoute = SafetyRouteImport.update({
  id: '/safety',
  path: '/safety',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleRoute = ScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveyRoute = SurveyRouteImport.update({
  id: '/survey',
  path: '/survey',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeRoute = UpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => rootRouteImport,
} as any)
const VoucherRequestRoute = VoucherRequestRouteImport.update({
  id: '/voucher-request',
  path: '/voucher-request',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionsIndexRoute = AuctionsIndexRouteImport.update({
  id: '/auctions/',
  path: '/auctions/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionsIdRoute = AuctionsIdRouteImport.update({
  id: '/auctions/$id',
  path: '/auctions/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutIndexRoute = CheckoutIndexRouteImport.update({
  id: '/checkout/',
  path: '/checkout/',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutCancelRoute = CheckoutCancelRouteImport.update({
  id: '/checkout/cancel',
  path: '/checkout/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/checkout/success',
  path: '/checkout/success',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreIndexRoute = ExploreIndexRouteImport.update({
  id: '/explore/',
  path: '/explore/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreClubFynnRoute = ExploreClubFynnRouteImport.update({
  id: '/explore/club-fynn',
  path: '/explore/club-fynn',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreCommunityMeetupsRoute = ExploreCommunityMeetupsRouteImport.update({
  id: '/explore/community-meetups',
  path: '/explore/community-meetups',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreDealersRoute = ExploreDealersRouteImport.update({
  id: '/explore/dealers',
  path: '/explore/dealers',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreEventsRoute = ExploreEventsRouteImport.update({
  id: '/explore/events',
  path: '/explore/events',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreGamesRoute = ExploreGamesRouteImport.update({
  id: '/explore/games',
  path: '/explore/games',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreLobbyRoute = ExploreLobbyRouteImport.update({
  id: '/explore/lobby',
  path: '/explore/lobby',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreMeetupsRoute = ExploreMeetupsRouteImport.update({
  id: '/explore/meetups',
  path: '/explore/meetups',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreDealerIdRoute = ExploreDealerIdRouteImport.update({
  id: '/explore/dealer/$id',
  path: '/explore/dealer/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreEventIdRoute = ExploreEventIdRouteImport.update({
  id: '/explore/event/$id',
  path: '/explore/event/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/500': typeof R500Route
  '/accounts': typeof AccountsRoute
  '/age-verification': typeof AgeVerificationRoute
  '/buy-voucher': typeof BuyVoucherRoute
  '/donate': typeof DonateRoute
  '/friends': typeof FriendsRoute
  '/link': typeof LinkRoute
  '/link-world': typeof LinkWorldRoute
  '/oauth-redirect': typeof OauthRedirectRoute
  '/party': typeof PartyRoute
  '/private-parties': typeof PrivatePartiesRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/safety': typeof SafetyRoute
  '/schedule': typeof ScheduleRoute
  '/status': typeof StatusRoute
  '/survey': typeof SurveyRoute
  '/upgrade': typeof UpgradeRoute
  '/voucher-request': typeof VoucherRequestRoute
  '/auctions/$id': typeof AuctionsIdRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/explore/club-fynn': typeof ExploreClubFynnRoute
  '/explore/community-meetups': typeof ExploreCommunityMeetupsRoute
  '/explore/dealers': typeof ExploreDealersRoute
  '/explore/events': typeof ExploreEventsRoute
  '/explore/games': typeof ExploreGamesRoute
  '/explore/lobby': typeof ExploreLobbyRoute
  '/explore/meetups': typeof ExploreMeetupsRoute
  '/auctions/': typeof AuctionsIndexRoute
  '/checkout/': typeof CheckoutIndexRoute
  '/explore/': typeof ExploreIndexRoute
  '/explore/dealer/$id': typeof ExploreDealerIdRoute
  '/explore/event/$id': typeof ExploreEventIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/500': typeof R500Route
  '/accounts': typeof AccountsRoute
  '/age-verification': typeof AgeVerificationRoute
  '/buy-voucher': typeof BuyVoucherRoute
  '/donate': typeof DonateRoute
  '/friends': typeof FriendsRoute
  '/link': typeof LinkRoute
  '/link-world': typeof LinkWorldRoute
  '/oauth-redirect': typeof OauthRedirectRoute
  '/party': typeof PartyRoute
  '/private-parties': typeof PrivatePartiesRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/safety': typeof SafetyRoute
  '/schedule': typeof ScheduleRoute
  '/status': typeof StatusRoute
  '/survey': typeof SurveyRoute
  '/upgrade': typeof UpgradeRoute
  '/voucher-request': typeof VoucherRequestRoute
  '/auctions/$id': typeof AuctionsIdRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/explore/club-fynn': typeof ExploreClubFynnRoute
  '/explore/community-meetups': typeof ExploreCommunityMeetupsRoute
  '/explore/dealers': typeof ExploreDealersRoute
  '/explore/events': typeof ExploreEventsRoute
  '/explore/games': typeof ExploreGamesRoute
  '/explore/lobby': typeof ExploreLobbyRoute
  '/explore/meetups': typeof ExploreMeetupsRoute
  '/auctions': typeof AuctionsIndexRoute
  '/checkout': typeof CheckoutIndexRoute
  '/explore': typeof ExploreIndexRoute
  '/explore/dealer/$id': typeof ExploreDealerIdRoute
  '/explore/event/$id': typeof ExploreEventIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/500': typeof R500Route
  '/accounts': typeof AccountsRoute
  '/age-verification': typeof AgeVerificationRoute
  '/buy-voucher': typeof BuyVoucherRoute
  '/donate': typeof DonateRoute
  '/friends': typeof FriendsRoute
  '/link': typeof LinkRoute
  '/link-world': typeof LinkWorldRoute
  '/oauth-redirect': typeof OauthRedirectRoute
  '/party': typeof PartyRoute
  '/private-parties': typeof PrivatePartiesRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/safety': typeof SafetyRoute
  '/schedule': typeof ScheduleRoute
  '/status': typeof StatusRoute
  '/survey': typeof SurveyRoute
  '/upgrade': typeof UpgradeRoute
  '/voucher-request': typeof VoucherRequestRoute
  '/auctions/$id': typeof AuctionsIdRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/explore/club-fynn': typeof ExploreClubFynnRoute
  '/explore/community-meetups': typeof ExploreCommunityMeetupsRoute
  '/explore/dealers': typeof ExploreDealersRoute
  '/explore/events': typeof ExploreEventsRoute
  '/explore/games': typeof ExploreGamesRoute
  '/explore/lobby': typeof ExploreLobbyRoute
  '/explore/meetups': typeof ExploreMeetupsRoute
  '/auctions/': typeof AuctionsIndexRoute
  '/checkout/': typeof CheckoutIndexRoute
  '/explore/': typeof ExploreIndexRoute
  '/explore/dealer/$id': typeof ExploreDealerIdRoute
  '/explore/event/$id': typeof ExploreEventIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/500'
    | '/accounts'
    | '/age-verification'
    | '/buy-voucher'
    | '/donate'
    | '/friends'
    | '/link'
    | '/link-world'
    | '/oauth-redirect'
    | '/party'
    | '/private-parties'
    | '/profile'
    | '/register'
    | '/safety'
    | '/schedule'
    | '/status'
    | '/survey'
    | '/upgrade'
    | '/voucher-request'
    | '/auctions/$id'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/explore/club-fynn'
    | '/explore/community-meetups'
    | '/explore/dealers'
    | '/explore/events'
    | '/explore/games'
    | '/explore/lobby'
    | '/explore/meetups'
    | '/auctions/'
    | '/checkout/'
    | '/explore/'
    | '/explore/dealer/$id'
    | '/explore/event/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/500'
    | '/accounts'
    | '/age-verification'
    | '/buy-voucher'
    | '/donate'
    | '/friends'
    | '/link'
    | '/link-world'
    | '/oauth-redirect'
    | '/party'
    | '/private-parties'
    | '/profile'
    | '/register'
    | '/safety'
    | '/schedule'
    | '/status'
    | '/survey'
    | '/upgrade'
    | '/voucher-request'
    | '/auctions/$id'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/explore/club-fynn'
    | '/explore/community-meetups'
    | '/explore/dealers'
    | '/explore/events'
    | '/explore/games'
    | '/explore/lobby'
    | '/explore/meetups'
    | '/auctions'
    | '/checkout'
    | '/explore'
    | '/explore/dealer/$id'
    | '/explore/event/$id'
  id:
    | '__root__'
    | '/'
    | '/500'
    | '/accounts'
    | '/age-verification'
    | '/buy-voucher'
    | '/donate'
    | '/friends'
    | '/link'
    | '/link-world'
    | '/oauth-redirect'
    | '/party'
    | '/private-parties'
    | '/profile'
    | '/register'
    | '/safety'
    | '/schedule'
    | '/status'
    | '/survey'
    | '/upgrade'
    | '/voucher-request'
    | '/auctions/$id'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/explore/club-fynn'
    | '/explore/community-meetups'
    | '/explore/dealers'
    | '/explore/events'
    | '/explore/games'
    | '/explore/lobby'
    | '/explore/meetups'
    | '/auctions/'
    | '/checkout/'
    | '/explore/'
    | '/explore/dealer/$id'
    | '/explore/event/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R500Route: typeof R500Route
  AccountsRoute: typeof AccountsRoute
  AgeVerificationRoute: typeof AgeVerificationRoute
  BuyVoucherRoute: typeof BuyVoucherRoute
  DonateRoute: typeof DonateRoute
  FriendsRoute: typeof FriendsRoute
  LinkRoute: typeof LinkRoute
  LinkWorldRoute: typeof LinkWorldRoute
  OauthRedirectRoute: typeof OauthRedirectRoute
  PartyRoute: typeof PartyRoute
  PrivatePartiesRoute: typeof PrivatePartiesRoute
  ProfileRoute: typeof ProfileRoute
  RegisterRoute: typeof RegisterRoute
  SafetyRoute: typeof SafetyRoute
  ScheduleRoute: typeof ScheduleRoute
  StatusRoute: typeof StatusRoute
  SurveyRoute: typeof SurveyRoute
  UpgradeRoute: typeof UpgradeRoute
  VoucherRequestRoute: typeof VoucherRequestRoute
  AuctionsIdRoute: typeof AuctionsIdRoute
  CheckoutCancelRoute: typeof CheckoutCancelRoute
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
  ExploreClubFynnRoute: typeof ExploreClubFynnRoute
  ExploreCommunityMeetupsRoute: typeof ExploreCommunityMeetupsRoute
  ExploreDealersRoute: typeof ExploreDealersRoute
  ExploreEventsRoute: typeof ExploreEventsRoute
  ExploreGamesRoute: typeof ExploreGamesRoute
  ExploreLobbyRoute: typeof ExploreLobbyRoute
  ExploreMeetupsRoute: typeof ExploreMeetupsRoute
  AuctionsIndexRoute: typeof AuctionsIndexRoute
  CheckoutIndexRoute: typeof CheckoutIndexRoute
  ExploreIndexRoute: typeof ExploreIndexRoute
  ExploreDealerIdRoute: typeof ExploreDealerIdRoute
  ExploreEventIdRoute: typeof ExploreEventIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/500': {
      id: '/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof R500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts': {
      id: '/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/age-verification': {
      id: '/age-verification'
      path: '/age-verification'
      fullPath: '/age-verification'
      preLoaderRoute: typeof AgeVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buy-voucher': {
      id: '/buy-voucher'
      path: '/buy-voucher'
      fullPath: '/buy-voucher'
      preLoaderRoute: typeof BuyVoucherRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donate': {
      id: '/donate'
      path: '/donate'
      fullPath: '/donate'
      preLoaderRoute: typeof DonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/friends': {
      id: '/friends'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof FriendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/link': {
      id: '/link'
      path: '/link'
      fullPath: '/link'
      preLoaderRoute: typeof LinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/link-world': {
      id: '/link-world'
      path: '/link-world'
      fullPath: '/link-world'
      preLoaderRoute: typeof LinkWorldRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth-redirect': {
      id: '/oauth-redirect'
      path: '/oauth-redirect'
      fullPath: '/oauth-redirect'
      preLoaderRoute: typeof OauthRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/party': {
      id: '/party'
      path: '/party'
      fullPath: '/party'
      preLoaderRoute: typeof PartyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/private-parties': {
      id: '/private-parties'
      path: '/private-parties'
      fullPath: '/private-parties'
      preLoaderRoute: typeof PrivatePartiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/safety': {
      id: '/safety'
      path: '/safety'
      fullPath: '/safety'
      preLoaderRoute: typeof SafetyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule': {
      id: '/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof ScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/survey': {
      id: '/survey'
      path: '/survey'
      fullPath: '/survey'
      preLoaderRoute: typeof SurveyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade': {
      id: '/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof UpgradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/voucher-request': {
      id: '/voucher-request'
      path: '/voucher-request'
      fullPath: '/voucher-request'
      preLoaderRoute: typeof VoucherRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auctions/': {
      id: '/auctions/'
      path: '/auctions'
      fullPath: '/auctions/'
      preLoaderRoute: typeof AuctionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auctions/$id': {
      id: '/auctions/$id'
      path: '/auctions/$id'
      fullPath: '/auctions/$id'
      preLoaderRoute: typeof AuctionsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/': {
      id: '/checkout/'
      path: '/checkout'
      fullPath: '/checkout/'
      preLoaderRoute: typeof CheckoutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/cancel': {
      id: '/checkout/cancel'
      path: '/checkout/cancel'
      fullPath: '/checkout/cancel'
      preLoaderRoute: typeof CheckoutCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/success': {
      id: '/checkout/success'
      path: '/checkout/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/': {
      id: '/explore/'
      path: '/explore'
      fullPath: '/explore/'
      preLoaderRoute: typeof ExploreIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/club-fynn': {
      id: '/explore/club-fynn'
      path: '/explore/club-fynn'
      fullPath: '/explore/club-fynn'
      preLoaderRoute: typeof ExploreClubFynnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/community-meetups': {
      id: '/explore/community-meetups'
      path: '/explore/community-meetups'
      fullPath: '/explore/community-meetups'
      preLoaderRoute: typeof ExploreCommunityMeetupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/dealers': {
      id: '/explore/dealers'
      path: '/explore/dealers'
      fullPath: '/explore/dealers'
      preLoaderRoute: typeof ExploreDealersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/events': {
      id: '/explore/events'
      path: '/explore/events'
      fullPath: '/explore/events'
      preLoaderRoute: typeof ExploreEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/games': {
      id: '/explore/games'
      path: '/explore/games'
      fullPath: '/explore/games'
      preLoaderRoute: typeof ExploreGamesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/lobby': {
      id: '/explore/lobby'
      path: '/explore/lobby'
      fullPath: '/explore/lobby'
      preLoaderRoute: typeof ExploreLobbyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/meetups': {
      id: '/explore/meetups'
      path: '/explore/meetups'
      fullPath: '/explore/meetups'
      preLoaderRoute: typeof ExploreMeetupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/dealer/$id': {
      id: '/explore/dealer/$id'
      path: '/explore/dealer/$id'
      fullPath: '/explore/dealer/$id'
      preLoaderRoute: typeof ExploreDealerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/event/$id': {
      id: '/explore/event/$id'
      path: '/explore/event/$id'
      fullPath: '/explore/event/$id'
      preLoaderRoute: typeof ExploreEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R500Route: R500Route,
  AccountsRoute: AccountsRoute,
  AgeVerificationRoute: AgeVerificationRoute,
  BuyVoucherRoute: BuyVoucherRoute,
  DonateRoute: DonateRoute,
  FriendsRoute: FriendsRoute,
  LinkRoute: LinkRoute,
  LinkWorldRoute: LinkWorldRoute,
  OauthRedirectRoute: OauthRedirectRoute,
  PartyRoute: PartyRoute,
  PrivatePartiesRoute: PrivatePartiesRoute,
  ProfileRoute: ProfileRoute,
  RegisterRoute: RegisterRoute,
  SafetyRoute: SafetyRoute,
  ScheduleRoute: ScheduleRoute,
  StatusRoute: StatusRoute,
  SurveyRoute: SurveyRoute,
  UpgradeRoute: UpgradeRoute,
  VoucherRequestRoute: VoucherRequestRoute,
  AuctionsIdRoute: AuctionsIdRoute,
  CheckoutCancelRoute: CheckoutCancelRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
  ExploreClubFynnRoute: ExploreClubFynnRoute,
  ExploreCommunityMeetupsRoute: ExploreCommunityMeetupsRoute,
  ExploreDealersRoute: ExploreDealersRoute,
  ExploreEventsRoute: ExploreEventsRoute,
  ExploreGamesRoute: ExploreGamesRoute,
  ExploreLobbyRoute: ExploreLobbyRoute,
  ExploreMeetupsRoute: ExploreMeetupsRoute,
  AuctionsIndexRoute: AuctionsIndexRoute,
  CheckoutIndexRoute: CheckoutIndexRoute,
  ExploreIndexRoute: ExploreIndexRoute,
  ExploreDealerIdRoute: ExploreDealerIdRoute,
  ExploreEventIdRoute: ExploreEventIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
